import { HStack, Tooltip } from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/all";

import { Icon } from "components/Icon";
import { useModal } from "components/Modal";
import { IconButton } from "components/IconButton";

import { CancellationUserAppointmentReasonModal } from "../../../CancellationUserAppointmentReasonModal";
import { AppointmentStatus } from "../../../../application/types/AppointmentStatus";
import { IAppointmentDetails } from "../../../../application/types/IAppointmentDetails";

interface IProps {
  appointment: IAppointmentDetails;
}

const ExpiredAppointmentActionButtons = ({ appointment }: IProps) => {
  const cancelReasonMessage = "Przyczyna anulowania";

  const { isOpen, onOpen, onClose } = useModal();

  return (
    <>
      <CancellationUserAppointmentReasonModal
        deleteReason={appointment.cancellationReason}
        isOpen={isOpen}
        onClose={onClose}
      />

      <HStack>
        {appointment.status === AppointmentStatus.Canceled && (
          <Tooltip label={cancelReasonMessage} aria-label={cancelReasonMessage}>
            <IconButton
              id={`expired-cancelled-appointment-${appointment.appointmentId}-icon-btn`}
              aria-label={cancelReasonMessage}
              background="transparent"
              icon={
                <Icon
                  w={5}
                  h={5}
                  color="black.900"
                  icon={AiOutlineInfoCircle}
                />
              }
              onMouseDown={(e) => {
                e.preventDefault();
              }}
              onClick={(e) => {
                e.stopPropagation();
                onOpen();
              }}
            />
          </Tooltip>
        )}
      </HStack>
    </>
  );
};

export { ExpiredAppointmentActionButtons };
